import React from 'react';
import { css } from '@emotion/react';
import { color } from '../defaults/styles/theme';
import mq from '../defaults/styles/mediaquerys';
import moment from 'moment';
import Link from '../link';
import Flags from '../../data/raw/flags';
import Clock from '../defaults/assets/svg/clock.svg';

export const AgendaElSmlContainer = ({children, className}) => {
  
  return(
    <ul className={className} css={css`
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-between;
      list-style: none;
      margin-left: 0;
    `}>
      {children}
    </ul>
  )
};


export const AgendaElSml = ({recordId, data, maxRow, placeholder}) => {
  let startTime = ""
  let eventDate = ""
  
  if ( !placeholder ) {
    startTime = moment(data.agenda_start_time).format("HH:mm")
    eventDate = moment(data.agenda_start_time).format("MMMM Do, YYYY")
  }
  
  const layout = 
    maxRow === 2 ? css`
      flex: 0 0 100%;
      ${mq[1]} {
        flex: 0 0 calc((100% - (0.5em * 1)) / 2);
      }
    ` : null;

  return (
    <li css={css`
      ${layout}
      background: ${!placeholder ? "white" : "none"};
      border-radius: 5px;
      margin-bottom: ${!placeholder ? ".5em" : "0"};
    `}>
      {!placeholder ? (
        <Link
          to={ `/${Flags.settings.protectedArea.url}/agenda/${recordId}` }
          css={css`
            text-decoration: none;
            padding: 1em;
            display: block;
          `}
        >
          <div css={css`
            display: flex;
            align-items: center;
          `}>
            <div css={css`
              background: ${color.main_dark};
              border-radius: 5px;
              padding: .25em .5em;
              display: flex;
              display: inline-flex;
              align-items: center;
              white-space: nowrap;
              margin-right: .5em;
              svg {
                height: 1em;
                width: auto;
                stroke: white;
                margin-right: .5em;
              }
            `}>
              <Clock />
              <p css={css`
                color: white;
                font-size: .65em;
                font-weight: 700;
              `}>{startTime}</p>
            </div>
            <p css={css`
              color: ${color.main_dark};
              font-size: .75em;
              font-weight: 600;
            `}>on {eventDate}</p>
          </div>

          <div css={css`
            margin-top: .75em;
            max-width: 90%;
          `}>
            <p css={css`
              margin-bottom: 0;
              font-size: .75em;
              color: ${color.main_dark};
              line-height: 1.4em;
            `}>
              {data.agenda_title}
            </p>
          </div>
        </Link>
      ) : null}
    </li>
  )
};